// Safe serialiser for JSON-LD injected into <script type="application/ld+json">.
// DOMPurify is an HTML sanitiser and corrupts JSON, so escape only the characters
// that could break out of the script element.
export const toJsonLd = (schema) =>
  JSON.stringify(schema)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026");
